export default {
  Revenue_PlansPage_SignedUp: 'Revenue_PlansPage_SignedUp',
  Revenue_PlansPage_CheckedOut: 'Revenue_PlansPage_CheckedOut',
  Revenue_SignupPage_Viewed_Page: 'Revenue_SignupPage_Viewed_Page',
  Revenue_SignupPage_SignedUp: 'Revenue_SignupPage_SignedUp',
  Revenue_TaggingPage_Checkedout: 'Revenue_TaggingPage_Checkedout',

  //pricing plans page revamp
  Revenue_PlansPage_Clicked_WatchPlanVideo: 'Revenue_PlansPage_Clicked_WatchPlanVideo',
  Revenue_PlansPage_Clicked_LearnMoreDropdown: 'Revenue_PlansPage_Clicked_LearnMoreDropdown',
  Revenue_PlansPage_Clicked_CollapseDropdown: 'Revenue_PlansPage_Clicked_CollapseDropdown',
  Revenue_PlansPage_Clicked_CardsArrow: 'Revenue_PlansPage_Clicked_CardsArrow',
  Revenue_PlansPage_ScrolledPast_Competitors: 'Revenue_PlansPage_ScrolledPast_Competitors',
  Revenue_PlansPage_ScrolledPast_FeatureTable: 'Revenue_PlansPage_ScrolledPast_FeatureTable',
  Revenue_PlansPage_Clicked_LearnMore: 'Revenue_PlansPage_Clicked_LearnMore',
  Revenue_PlansPage_Viewed_o2o: 'Revenue_PlansPage_Viewed_o2o',
  userAuthenticatedSuccessfully: 'userAuthenticatedSuccessfully'
}
